import script from "./BaseTemplateLayoutGridSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateLayoutGridSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateLayoutGridSetting.vue?vue&type=style&index=0&id=e9c8e896&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c8e896"]])

export default __exports__